// The screen-capture lambda renders this page with a service token that has
// no user record behind it, so /users/me can never succeed there. The page
// must render without a signed-in user; its API calls authenticate through
// the accessToken cookie the lambda sets before navigating.
export const isHeadlessCapturePath = (path: string) =>
  /^\/settings\/custom-reports\/[^/]+\/print-preview\/?$/.test(path);
